import React from 'react';
import { Route, Routes } from 'react-router-dom';

import LazyPage from '../common/components/LazyPage';
import AuthRoutes from './AuthRoutes';
import useRouting from './hooks/useRouting';
import AuthLayout from './layouts/AuthLayout';
import SiteError from './layouts/components/SiteError';
import SiteLoading from './layouts/components/SiteLoading';
import DashboardLayout from './layouts/DashboardLayout';
import AnonymousOnlyRoute from './outlets/AnonymousOnlyRoute';
import ProtectedRoute from './outlets/ProtectedRoute';

const DashboardRoutes = React.lazy(() => import('./DashboardRoutes'));
const StyleGuide = React.lazy(() => import('../pages/StyleGuide'));

export default function Routing() {
  const { showError, showLoading } = useRouting();

  if (showLoading) {
    return <SiteLoading />;
  }

  if (showError) {
    return <SiteError />;
  }

  return (
    <Routes>
      <Route element={<ProtectedRoute />}>
        <Route element={<DashboardLayout />}>
          <Route
            path="*"
            element={
              <LazyPage>
                <DashboardRoutes />
              </LazyPage>
            }
          />
          <Route
            path="guide/*"
            element={
              <LazyPage>
                <StyleGuide />
              </LazyPage>
            }
          />
        </Route>
      </Route>
      <Route element={<AnonymousOnlyRoute />}>
        <Route element={<AuthLayout />}>
          <Route path="auth/*" element={<AuthRoutes />} />
        </Route>
      </Route>
    </Routes>
  );
}
